import React, { useEffect, useState, useRef } from "react";
import {
	Block,
	BlockContent,
	BlockDes,
	BlockHead,
	BlockTitle,
	Button,
	Icon,
	PreviewCard,
} from "../../components/Component";
import Logo from "../../images/logo.png";
import LogoDark from "../../images/logo-dark.png";
import { Spinner, FormGroup, Toast, ToastHeader, ToastBody } from "reactstrap";
import PageContainer from "../../layout/page-container/PageContainer";
import { useSelector, useDispatch } from "react-redux";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import { useForm } from "react-hook-form";
import { Link, useLocation, useParams } from "react-router-dom";
import { QueryClient, QueryClientProvider, useQuery, useMutation } from "@tanstack/react-query";
import { toast, ToastContainer } from "react-toastify";

import { loginAxios } from '../../config/axios.config';

const Register = ({ history }) => {

    const dispatch = useDispatch();

	const location = useLocation();
	const urlParam = useParams();
	const { errors, register, handleSubmit, watch, reset } = useForm();
	const password = useRef({});
	password.current = watch("password", "");

	const [passState, setPassState] = useState(false);
	// const [cPassState, setCpassState] = useState(false);
	// const [loading, setLoading] = useState(false);



	const resetPasswordCall = async (params) => {
		try {
			const { data } = await loginAxios.post("designers/reset-password", params);
			return data;

		} catch (error) {
			return Promise.reject(error);
		}
	};

	const resetPassword = useMutation(resetPasswordCall, {
		onSettled(data, error) {

			if (data) {
				// console.log('found data')
				// console.log(data);
				// handleToastVisible(data.message);
				console.log(data.message)
				dispatch({ type: 'RESET_PASS_SUCCESS_MESSAGE', payload: data.message })
				// toast.success(data.message, {
				// 	position: "top-right",
				// 	autoClose: 2000,
				// 	hideProgressBar: true,
				// 	closeOnClick: true,
				// 	progress: false,
				//   });

				history.push('/auth-login');
			} else if (error) {
				// console.log('found ERROR')
				console.log(error);
				// handleToastVisible(error.response.data.message);
				toast.error(error.response.data.message, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: true,
					closeOnClick: true,
					progress: false,
				  });
			}
		}
	})


	const registerUserCall = async (params) => {
		try {
			const { data } = await loginAxios.post("designers/register", params);
			return data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

	const registerUser = useMutation(registerUserCall, {
		onError() {

		},
		onMutate() {

		},
		onSuccess() {

		},
		onSettled(data, error) {

			if (data) {
				// console.log('found data')
				// console.log(data);
			
				dispatch({ type: 'REGISTER_SUCCESS_MESSAGE', payload: data.message })
				// toast.success(data.message, {
				// 	position: "top-right",
				// 	autoClose: 2000,
				// 	hideProgressBar: true,
				// 	closeOnClick: true,
				// 	progress: false,
				// 	onClose: () => {
				// 		dispatch({ type: 'REGISTER_SUCCESS_MESSAGE', payload: '' })
				// 	}
				//   });
				// handleToastVisible(data.message);
				history.push('/auth-login');
			} else if (error) {
				// console.log('found ERROR')
				console.log(error);
				// handleToastVisible(error.response.data.message);
				toast.error(error.response.data.message, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: true,
					closeOnClick: true,
					progress: false,
				  });
			}
		}
	})


	const handleFormSubmit = (data) => {
		// console.log(data);
		// setLoading(true);
		if (location.pathname != '/auth-register') {
			var params = {
				email: data.email,
				token: urlParam.token_val,
				password: data.password,
				cpassword: data.cpassword
			}
			// console.log(urlParam.token_val);
			resetPassword.mutate(params);
		} else {
			registerUser.mutate(data);
		}
		// setTimeout(() => history.push(`${process.env.PUBLIC_URL}/auth-success`), 2000);
	};

	// console.log(registerUser.status);
	// useEffect(() => {
	//   console.log(data)
	// }, [data]);

	// const [visible, setVisible] = useState(false)
	// const [toastMsg, setToastMsg] = useState('');

	// const handleToastVisible = (msg) => {
	// 	setVisible(true);
	// 	setToastMsg(msg);
	// 	setTimeout(() => {
	// 		setVisible(false);
	// 		setToastMsg('');
	// 	}, 1500)

	// }

	return (
		<React.Fragment>
			<Head title="Register" />
			<PageContainer>

				{/* <div style={{ position: "fixed", top: 10, right: 10, zIndex: 9999 }}>
					<Toast isOpen={visible}>
						<ToastHeader>
							Toast title
						</ToastHeader>
						<ToastBody>
							{toastMsg}
						</ToastBody>
					</Toast>
				</div> */}

				<Block className="nk-block-middle nk-auth-body  wide-xs">
					<div className="brand-logo pb-4 text-center">
						<Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
							<img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
							<img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
						</Link>
					</div>
					<PreviewCard className="card-bordered" bodyClass="card-inner-lg">

						{location.pathname != '/auth-register' ? <>
							<BlockHead>
								<BlockContent>
									<BlockTitle tag="h4">Reset Password</BlockTitle>
									<BlockDes>
										<p>Set your new password</p>
									</BlockDes>
								</BlockContent>
							</BlockHead>
						</> :
							<BlockHead>
								<BlockContent>
									<BlockTitle tag="h4">Register</BlockTitle>
									<BlockDes>
										<p>Create New Designer Panel Account</p>
									</BlockDes>
								</BlockContent>
							</BlockHead>
						}

						<form className="is-alter" onSubmit={handleSubmit(handleFormSubmit)}>
							{/* <FormGroup>
                <label className="form-label" htmlFor="name">
                  Name
                </label>
                <div className="form-control-wrap">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter your name"
                    ref={register({ required: true })}
                    className="form-control-lg form-control"
                  />
                  {errors.name && <p className="invalid">This field is required</p>}
                </div>
              </FormGroup> */}
							<FormGroup>
								<div className="form-label-group">
									<label className="form-label" htmlFor="default-01">
										Email<span style={{ color: "#f3245f" }}>*</span>
									</label>
								</div>
								<div className="form-control-wrap">
									<input
										type="text"
										bssize="lg"
										id="default-01"
										name="email"
										ref={register({
											required: "This field is required",
											// required: true,
											pattern: {
												value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
												message: "Please enter valid email-id",
											},
										})}
										className="form-control-lg form-control"
										placeholder="Enter your email address"
									/>
									{errors.email && <p className="invalid">This field is required</p>}
								</div>
							</FormGroup>


							<FormGroup>
								<div className="form-label-group">
									<label className="form-label" htmlFor="password">Password</label>
								</div>
								<div className="form-control-wrap">
									<a
										href="#password"
										onClick={(ev) => {
											ev.preventDefault();
											setPassState(!passState);
										}}
										className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
									>
										<Icon name="eye" className="passcode-icon icon-show"></Icon>
										<Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
									</a>
									<input
										type={passState ? "text" : "password"}
										id="password"
										name="password"
										ref={register({
											required: "This field is required",
											pattern: {
												value: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
												message: "Min 8 letter, with at least a symbol, upper and lower case letters and a number",
											},
										})}
										placeholder="New Password"
										className={`form-control-lg form-control is-hidden`}
									/>
									{errors.password && <span className="invalid">{errors.password.message}</span>}
								</div>
							</FormGroup>
							<FormGroup>
								<div className="form-label-group">
									<label className="form-label" htmlFor="re-password">
										Re-enter Password
									</label>
								</div>
								<div className="form-control-wrap">
									<a
										href="#re-password"
										onClick={(ev) => {
											ev.preventDefault();
											setPassState(!passState);
										}}
										className={`form-icon lg form-icon-right passcode-switch is-hidden`}
									>
										{/* <Icon name="eye" className="passcode-icon icon-show"></Icon>
                <Icon name="eye-off" className="passcode-icon icon-hide"></Icon> */}
									</a>
									<input
										type={"password"}
										id="re-password"
										name="cpassword"
										ref={register({
											required: "This field is required",
											pattern: {
												value: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
												message: "Min 8 letter, with at least a symbol, upper and lower case letters and a number",
											},
											validate: value =>
												value === password.current || "Password not matched"
										})}
										placeholder="Re-enter Password"
										className={`form-control-lg form-control is-hidden`}
									/>
									{errors.cpassword && <span className="invalid">{errors.cpassword.message}</span>}
								</div>
							</FormGroup>

							<FormGroup>
								<Button type="submit" color="primary" size="lg" className="btn-block">
									{registerUser.isLoading ? <Spinner size="sm" color="light" /> : (location.pathname != '/auth-register' ? "Reset Password" : "Request Verification Link")
									}

								</Button>
							</FormGroup>
						</form>
						{location.pathname != '/auth-register' ? <></> :
							<div className="form-note-s2 text-center pt-4">
								{" "}
								Already have an account?{" "}
								<Link to={`${process.env.PUBLIC_URL}/auth-login`}>
									<strong>Sign in instead</strong>
								</Link>
							</div>
						}
						{/* <div className="text-center pt-4 pb-3">
              <h6 className="overline-title overline-title-sap">
                <span>OR</span>
              </h6>
            </div> */}
						{/* <ul className="nav justify-center gx-8">
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#socials"
                  onClick={(ev) => {
                    ev.preventDefault();
                  }}
                >
                  Facebook
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#socials"
                  onClick={(ev) => {
                    ev.preventDefault();
                  }}
                >
                  Google
                </a>
              </li>
            </ul> */}
					</PreviewCard>
				</Block>
				{/* <AuthFooter /> */}
			</PageContainer>
			<ToastContainer />
		</React.Fragment>
	);
};
export default Register;
